import * as yup from "yup";

export const changePasswordValidationSchema = yup.object().shape({
  password: yup.string().required("requiredLogin"),
  checkPassword: yup.string().required("requiredPassword"),
});
